// extracted by mini-css-extract-plugin
module.exports = {"stepsNav":"Service_stepsNav__2u5Bk","navLink":"Service_navLink__2BI1X","active":"Service_active__3YLYD","dragDemo":"Service_dragDemo__332Qk"};